"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoppingCart = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const ShoppingCart_1 = __importDefault(require("@mui/icons-material/ShoppingCart"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const useLogin_1 = __importDefault(require("../../../common/helpers/Hooks/useLogin"));
const HandoverScreen_1 = __importDefault(require("../Other/HandoverScreen"));
const ProductCatalogForm_1 = __importDefault(require("./ProductCatalogForm"));
const Navigation_1 = __importDefault(require("./Navigation"));
const Menu_1 = __importDefault(require("./Menu"));
const ProductDetail_1 = __importDefault(require("./ProductDetail"));
const BookingLimitsErrorOrNotice_1 = __importDefault(require("../Booking/BookingLimitsErrorOrNotice"));
const ShoppingCartWrapper = styled_components_1.default.div `
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1102;
    background: #fff;
    height: 100%;
    width: 100%;
    overflow: scroll;
    .MuiSnackbar-root {
        bottom: 100px;
    }

    .booking-limits-notice {
        max-width: 600px;
        margin: 3vmin auto 0;
    }
`;
const WidthWrapper = styled_components_1.default.div `
    max-width: 600px;
    margin: 0 auto;
    padding: 0 16px 0px 16px;
`;
const ErrorWrapper = styled_components_1.default.div `
    text-align: center;
    padding: 20px;
`;
const OrderCompletedWrapper = styled_components_1.default.div `
    color: rgba(0, 0, 0, 0.87);
    height: calc( 100vh - 56px );
    @media (min-width: 600px) {
        height: calc(100vh - 64px);
    }
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
        text-align: center;
    }
    h1 {
        font-size: 2rem;
        margin-top: 0;
    }
    a {
        margin-top: 15px;
        color: ${(props) => props.theme.palette.primary.main};
        text-transform: uppercase;
        border: ${(props) => `1px solid ${props.theme.palette.primary.main}`};
        border-radius: 0.2rem;
        padding: 0 14px 0 14px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const ProductCatalogFormVisibilityWrapper = styled_components_1.default.div `
    display: ${({ $isHidden }) => ($isHidden ? "none" : "block")};
`;
const ShoppingCart = (props) => {
    const [showMenu, setShowMenu] = (0, react_1.useState)(false);
    const [showDiscardShoppingCartDialog, setShowDiscardShoppingCartDialog] = (0, react_1.useState)(false);
    const [showProduct, setShowProduct] = (0, react_1.useState)(false);
    const [orderCompleted, setOrderCompleted] = (0, react_1.useState)(false);
    const [orderCompletedData, setOrderCompletedData] = (0, react_1.useState)(null);
    const [toast, setToast] = (0, react_1.useState)("");
    const [error, setError] = (0, react_1.useState)("");
    const [product, setProduct] = (0, react_1.useState)("");
    const [headline, setHeadline] = (0, react_1.useState)("");
    const [basket, setBasket] = (0, react_1.useState)([]);
    const [showProductCatalogForm, setShowProductCatalogForm] = (0, react_1.useState)(false);
    const [isShoppingcartMandatory, setIsShoppingcartMandatory] = (0, react_1.useState)(false);
    const [isFetching, setIsFetching] = (0, react_1.useState)(true);
    const [bookingNotice, setBookingNotice] = (0, react_1.useState)("");
    const [orderData, setOrderData] = (0, react_1.useState)(null);
    const { currentLocale, userData, history, appData, } = props;
    const isGutWenghof = appData.brandSlug === "gut-wenghof";
    const { token } = userData;
    const { isLoginRequired, loginUrl } = (0, useLogin_1.default)(userData);
    const { content } = props.activeItem;
    const { shoppingCartCatalogId } = content;
    const availabilityId = content.availability.id;
    const { kidsClubEnabled } = content.availability;
    if (kidsClubEnabled) {
        return (react_1.default.createElement(HandoverScreen_1.default, null));
    }
    const showProductDetail = (data) => {
        setProduct(data);
        setShowProduct(true);
    };
    const hideProductDetail = () => {
        setShowProduct(false);
    };
    const showShoppingMenu = () => {
        setShowMenu(true);
    };
    const hideShoppingMenu = () => {
        setShowProductCatalogForm(true);
        setShowMenu(false);
    };
    const hideToast = () => {
        setToast("");
    };
    const closeShoppingCart = () => {
        history.goBack();
    };
    const showDiscardDialog = () => {
        if (orderData) {
            setShowDiscardShoppingCartDialog(true);
        }
        else {
            closeShoppingCart();
        }
    };
    const handleShoppingCartDiscard = (action = "") => {
        if (action === "confirm") {
            closeShoppingCart();
        }
        else {
            setShowDiscardShoppingCartDialog(false);
        }
    };
    const reviewOrder = (basketItems, action = "add") => {
        if (basketItems.length < 1) {
            setOrderData(null);
            setBasket([]);
            if (action === "delete") {
                setToast(i18n_js_1.default.t("flash.item_deleted"));
            }
            return;
        }
        let order = "";
        basketItems.map((item) => {
            if (item.productId) {
                order = `${order}&order[line_items][][comment]=${item.comment}&order[line_items][][product_id]=${item.productId}&order[line_items][][quantity]=${item.quantity}`;
            }
            return item;
        });
        apiService_1.default.reviewShoppingCartOrder(currentLocale, token, shoppingCartCatalogId, order).then((orderReview) => {
            if (orderReview.status === "success") {
                setOrderData(orderReview);
                const basketItemsWithoutServiceFee = basketItems.filter((basketItem) => Object.hasOwnProperty.call(basketItem, "productId"));
                setBasket(basketItemsWithoutServiceFee);
                if (action === "add") {
                    setToast(i18n_js_1.default.t("item_added"));
                }
            }
            else {
                setError(orderReview.message);
            }
        });
    };
    const addToBasket = (items) => {
        reviewOrder([...basket, ...items]);
    };
    const deleteItemFromBasket = (itemIndex) => {
        const updatedBasket = basket.filter((basketItem, basketIndex) => basketIndex !== itemIndex);
        reviewOrder(updatedBasket, "delete");
    };
    const handleNavigationClick = () => {
        if (showProduct) {
            return hideProductDetail();
        }
        if (showMenu) {
            if (isShoppingcartMandatory) {
                history.goBack();
            }
            return hideShoppingMenu();
        }
        if (orderCompleted) {
            return closeShoppingCart();
        }
        return showDiscardDialog();
    };
    const renderShoppingCart = () => {
        if (error) {
            return (react_1.default.createElement(ErrorWrapper, null, error));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Navigation_1.default, { icon: showMenu ? "close" : "arrow_back", onClick: handleNavigationClick, headline: headline }),
            react_1.default.createElement(material_1.Toolbar, null),
            showProduct && (react_1.default.createElement(ProductDetail_1.default, { shoppingCartCatalogId: shoppingCartCatalogId, data: product, hideProduct: hideProductDetail, addToBasket: addToBasket })),
            showMenu && !showProduct && (react_1.default.createElement(react_1.default.Fragment, null,
                bookingNotice !== "" &&
                    react_1.default.createElement(material_1.Box, { className: "booking-limits-notice" },
                        react_1.default.createElement(BookingLimitsErrorOrNotice_1.default, { bookingMessage: bookingNotice })),
                react_1.default.createElement(Menu_1.default, { orderData: orderData, shoppingCartCatalogId: shoppingCartCatalogId, showProduct: showProductDetail, hideMenu: hideShoppingMenu }))),
            orderCompleted && orderCompletedData && (react_1.default.createElement(OrderCompletedWrapper, null, orderCompletedData.texts.text && (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                    __html: orderCompletedData.texts.text,
                } })))),
            (showProductCatalogForm || (!isShoppingcartMandatory && !isFetching && !orderCompleted)) && (react_1.default.createElement(ProductCatalogFormVisibilityWrapper, { "$isHidden": showMenu || showProduct || orderCompleted },
                react_1.default.createElement(ProductCatalogForm_1.default, { activeItem: props.activeItem, deleteItemFromBasket: deleteItemFromBasket, orderData: orderData, shoppingCartCatalogId: shoppingCartCatalogId, availabilityId: availabilityId, showMenu: showShoppingMenu, contentType: content.type, reviewOrder: reviewOrder, setShowProductCatalogForm: setShowProductCatalogForm, setOrderCompleted: setOrderCompleted, setOrderCompletedData: setOrderCompletedData })))));
    };
    (0, react_1.useEffect)(() => {
        if (shoppingCartCatalogId) {
            apiService_1.default.getShoppingCartCatalog(props.currentLocale, token, shoppingCartCatalogId, content.availability.id).then((data) => {
                if (data.status === "success") {
                    const shoppingCartField = data.fields.find((field) => field.type === "shopping_cart");
                    setHeadline(data.texts.title);
                    if (shoppingCartField === null || shoppingCartField === void 0 ? void 0 : shoppingCartField.mandatory) {
                        setIsShoppingcartMandatory(true);
                        showShoppingMenu();
                    }
                    setIsFetching(false);
                }
                if (data.notice) {
                    setBookingNotice(data.notice.info);
                }
            });
        }
        else {
            setError("No shopping cart catalog id provided.");
        }
    }, []);
    if (isLoginRequired) {
        window.location.href = loginUrl;
        return (react_1.default.createElement(react_1.default.Fragment, null));
    }
    return (react_1.default.createElement(ShoppingCartWrapper, null,
        react_1.default.createElement(WidthWrapper, null, renderShoppingCart()),
        react_1.default.createElement(material_1.Snackbar, { onClose: hideToast, autoHideDuration: 4000, open: Boolean(toast), message: toast, anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            }, action: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.IconButton, { size: "small", "aria-label": "close", color: "inherit" },
                    react_1.default.createElement(ShoppingCart_1.default, { fontSize: "small" })))) }),
        react_1.default.createElement(material_1.Dialog, { open: showDiscardShoppingCartDialog, TransitionComponent: Transition, keepMounted: true, onClose: () => handleShoppingCartDiscard(), "aria-describedby": "alert-dialog-slide-description" },
            react_1.default.createElement(material_1.DialogTitle, null, i18n_js_1.default.t("discard_shopping_basket")),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => handleShoppingCartDiscard(), sx: isGutWenghof ? { color: "#d3cdc1" } : undefined }, i18n_js_1.default.t("cancel")),
                react_1.default.createElement(material_1.Button, { onClick: () => handleShoppingCartDiscard("confirm"), sx: isGutWenghof ? { color: "#d3cdc1" } : undefined }, "Ok")))));
};
exports.ShoppingCart = ShoppingCart;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
    baseUrl: store.getValue("baseUrl"),
    appData: store.getValue("appData"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.ShoppingCart));
